export default {
    methods: {
        displayTimestamp(dateTime) {
            let dateTimeMoment = moment.utc(dateTime).tz(window.itgTimezone);
            return dateTimeMoment.fromNow() + ' (' + dateTimeMoment.format('ddd DD MMM') + ' at ' + dateTimeMoment.format('h:mm A') + ')';
        },

        displayTimeOpen(dateTime) {
            let dateTimeMoment = moment.utc(dateTime).tz(window.itgTimezone);
            return dateTimeMoment.fromNow(true);
        },

        displayTimeAgo(dateTime) {
            let dateTimeMoment = moment.utc(dateTime).tz(window.itgTimezone);
            return dateTimeMoment.fromNow(false);
        },

        formatDate(axumDate) {
           return moment.utc(axumDate).tz(window.itgTimezone).format('DD/MM/YYYY') ;
        },

        formatDateCustomFormat(dateTime, format='DD/MM/YYYY') {
            return moment.utc(dateTime).tz(window.itgTimezone).format(format) ;
        }
    }
}
